import dayjs from 'dayjs';

export const formatDate = (
  dateStr: Date | null | undefined,
  format: string = 'MMM DD, YYYY'
): string => (dateStr && dayjs(dateStr).format(format)) || '';
